/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Υποστήριξη',
    lead: 'Όλα τα αιτήματα υποστήριξης της πλατφόρμας, με φιλτράρισμα κατά κατάσταση και προτεραιότητα.',
    filterStatus: 'Κατάσταση',
    filterPriority: 'Προτεραιότητα',
    allStatuses: 'Όλες οι καταστάσεις',
    allPriorities: 'Όλες οι προτεραιότητες',
    empty: 'Κανένα αίτημα δεν ταιριάζει με αυτά τα φίλτρα.',
    rowsLabel: 'τα αιτήματα',
    subject: 'Θέμα',
    company: 'Εταιρεία',
    status: 'Κατάσταση',
    priority: 'Προτεραιότητα',
    createdAt: 'Άνοιξε',
  },
  status: {
    open: 'Ανοιχτό',
    in_progress: 'Σε εξέλιξη',
    resolved: 'Επιλύθηκε',
    closed: 'Κλειστό',
  },
  priority: {
    low: 'Χαμηλή',
    normal: 'Κανονική',
    high: 'Υψηλή',
    urgent: 'Επείγουσα',
  },
  detail: {
    thisTicket: 'αυτό το αίτημα',
    requesterTitle: 'Αιτών',
    requesterLabel: 'ο αιτών',
    controlsTitle: 'Κατάσταση & προτεραιότητα',
    save: 'Αποθήκευση',
    threadTitle: 'Συνομιλία',
    threadEmpty: 'Δεν υπάρχουν ακόμη μηνύματα.',
    replyLabel: 'Απάντηση',
    reply: 'Αποστολή απάντησης',
  },
} as const;
